import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Landing from './pages/LandingPage';
import Login from './pages/LoginPage';
import Register from './pages/RegisterPage';
import Home from './pages/HomePage';
import UserList from './pages/UserManagementPage';
import PendingList from './pages/PendingPostPage';
import Service from './pages/ServicePage';
import ApprovePost from './pages/ApprovePostPage';
import OrderList from './pages/OrderManagementPage';
import PostDetails from './pages/PostDetailsPage';
import CreatePage from './pages/CreatePostPage';
import Profile from './pages/ProfilePage';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route exact path="/login" element={<Login/>}/>
      <Route exact path="/register" element={<Register/>}/>
      <Route exact path="/home" element={<Home/>}/>
      <Route exact path="/users" element={<UserList/>}/>
      <Route exact path="/posts" element={<PendingList/>}/>
      <Route exact path="/service" element={<Service/>}/>
      <Route exact path="/approve" element={<ApprovePost/>}/>
      <Route exact path="/orders" element={<OrderList/>}/>
      <Route exact path="/createpost" element={<CreatePage/>}/>
      <Route exact path="/post-details" element={<PostDetails/>}/>
      <Route exact path="/profile" element={<Profile/>}/>
      <Route index exact path="/" element={<Landing/>}/>
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
